var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 0H1.87501C0.841067 0 0 0.841066 0 1.87501V13.125C0 14.1589 0.841067 15 1.87501 15H18.125C19.1589 15 20 14.1589 20 13.125V1.87501C20 0.841066 19.1589 0 18.125 0ZM18.125 1.24999C18.2099 1.24999 18.2907 1.26761 18.3645 1.29838L10 8.54797L1.63542 1.29838C1.70927 1.26765 1.79005 1.24999 1.87497 1.24999H18.125ZM18.125 13.75H1.87501C1.53017 13.75 1.24999 13.4698 1.24999 13.1249V2.61901L9.59045 9.84739C9.70826 9.9493 9.85413 9.99999 10 9.99999C10.1459 9.99999 10.2917 9.94934 10.4096 9.84739L18.75 2.61901V13.125C18.75 13.4698 18.4698 13.75 18.125 13.75Z",
    fill: "#929597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b4a6c0fe9b4f4a0e74205b1ef2a321ad.svg";
export { ForwardRef as ReactComponent };